import registerGlobalComponents from "~/utils/register-global-components";

function registerWidgets(app, widgetsContext) {
  const alterComponent = (componentConfig) => {
    componentConfig.props = componentConfig.props || {};
    componentConfig.props.config = componentConfig.props.config || {};
  };

  registerGlobalComponents(app, widgetsContext, alterComponent);
}

export default function registerAllComponents(app, context) {
  const { globalComponentsContext, widgetsContext } = context.allRequireContext;

  registerGlobalComponents(
    app,
    require.context("~/components/global", true, /.*\.vue$/)
  );
  registerGlobalComponents(app, globalComponentsContext);
  registerWidgets(app, widgetsContext);
}
